// Importing the component responsible for defining routes
import DefRoutes from "./components/DefRoutes";
import './App.css'

// Main component of the application
function App() {
  // Rendering the component which defines routes
  return (
    <div className="App">
      <DefRoutes/>
    </div>
  );
}

export default App;
